import React from 'react';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import styled from 'styled-components';
import Body from 'ui/Typography/Body';
import { useIntl } from 'react-intl';
import SkapaTooltip from 'ui/Tooltip/SkapaTooltip';
import { e2e } from 'utils/queryUtils';

export const Listitem = styled.li`
  padding: 0;
  margin: 0;
  list-style-type: none;

  &[data-disabled='true'] {
    cursor: default;
    pointer-events: none;
    opacity: 0.5;
  }
`;

const AdditionalItemsButton = styled.button`
  width: ${({ theme }) => theme.space.xxl};
  height: ${({ theme }) => theme.space.xxl};
  background: ${({ theme }) => theme.colors.grey[100]};
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  user-select: none;
  justify-self: center;
  border: none;

  @media (hover: hover) {
    &:hover {
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1), 0 8px 8px rgba(0, 0, 0, 0.04);
    }
  }
  &:focus {
    outline: 0.125rem solid ${({ theme }) => theme.colors.feedback.focus};
    outline-offset: 4px;
  }
`;

const AdditionalItemsText = styled(Body)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
`;

type Props = {
  onClick: () => void;
  numberOfItems: number;
  disabled?: boolean;
  additionalItemsText?: string;
};

const AdditionalItems = ({
  onClick,
  numberOfItems,
  disabled,
  additionalItemsText,
  ...props
}: Props) => {
  const { formatMessage } = useIntl();
  const selectedMenuAdditionalItemsText = additionalItemsText
    ? `+${numberOfItems} ${additionalItemsText.toLowerCase()}`
    : `+${numberOfItems} ${formatMessage({
        id: 'storageone.selectedProductAdditionalItems'
      }).toLowerCase()}`;

  return (
    <Listitem data-disabled={disabled} aria-disabled={disabled}>
      {e2e() ? (
        <AdditionalItemsButton
          onClick={event => {
            disabled ? event.preventDefault() : onClick();
          }}
          data-disabled={disabled}
          aria-disabled={disabled}
          aria-label={
            numberOfItems +
            ' ' +
            formatMessage({ id: 'storageone.selectedProductAdditionalItems' }).toLowerCase()
          }
          {...props}
        >
          <AdditionalItemsText fontWeight="bold" type={ThemeFontStyleTypeEnum.bodySmall}>
            {`+${numberOfItems}`}
          </AdditionalItemsText>
        </AdditionalItemsButton>
      ) : (
        <SkapaTooltip
          tooltipText={selectedMenuAdditionalItemsText}
          tooltipButtonLabel={selectedMenuAdditionalItemsText}
          interactiveCustomTrigger
        >
          <AdditionalItemsButton
            onClick={event => {
              disabled ? event.preventDefault() : onClick();
            }}
            data-disabled={disabled}
            aria-disabled={disabled}
            aria-label={
              numberOfItems +
              ' ' +
              formatMessage({ id: 'storageone.selectedProductAdditionalItems' }).toLowerCase()
            }
            {...props}
          >
            <AdditionalItemsText fontWeight="bold" type={ThemeFontStyleTypeEnum.bodySmall}>
              {`+${numberOfItems}`}
            </AdditionalItemsText>
          </AdditionalItemsButton>
        </SkapaTooltip>
      )}
    </Listitem>
  );
};

export default AdditionalItems;
